var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.555,
    cy: 128.184,
    r: 127.555,
    fill: "#1C1C20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BAFFA9",
    d: "m178.496 124.737l-14.205-14.205l7.306-30.035l-30.441 6.9l-13.8-13.8l68.187-17.047z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ACB16",
    d: "M154.956 218.901L33.192 97.138L101.38 80.09l13.8 13.8l-48.706 12.176l27.6 27.6l32.064-7.712l-8.117 31.658l27.6 27.6l12.176-48.705l14.205 14.206z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmmet);
export default __webpack_public_path__ + "static/media/emmet.39750156d8248f16e8123d75f63ea64e.svg";
export { ForwardRef as ReactComponent };